import React from "react";
import { motion } from "framer-motion";
import { Mail, Loader2, ShieldCheck } from "lucide-react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

export default function ContactOTPStep({ email, otp, setOtp, loading, onVerify, onResend, onBack }) {
  return (
    <motion.div
      key="otp-step"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.35 }}
      className="space-y-6"
      data-testid="otp-step"
    >
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full border border-blue-500/40 bg-blue-500/10 flex items-center justify-center mb-4">
          <Mail className="w-5 h-5 text-blue-400" />
        </div>
        <h4 className="font-display text-xl font-medium tracking-tight">Check your inbox</h4>
        <p className="mt-2 text-sm text-zinc-400">
          We sent a 6-digit code to <span className="text-white">{email}</span>
        </p>
      </div>

      <div className="flex justify-center">
        <InputOTP
          maxLength={6}
          value={otp}
          onChange={setOtp}
          data-testid="contact-otp-input"
          containerClassName="gap-3"
        >
          <InputOTPGroup className="gap-3">
            {[0, 1, 2, 3, 4, 5].map((slotIndex) => (
              <InputOTPSlot
                key={`otp-slot-${slotIndex}`}
                index={slotIndex}
                className="w-12 h-14 text-lg font-mono rounded-md border border-white/15 bg-white/[0.04] text-white first:rounded-md last:rounded-md border-l"
              />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </div>

      <div className="flex flex-col gap-3">
        <button
          onClick={onVerify}
          disabled={loading || otp.length !== 6}
          data-testid="contact-verify-button"
          className="group w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white text-black text-sm font-medium hover:bg-zinc-100 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Verifying…
            </>
          ) : (
            <>
              <ShieldCheck className="w-4 h-4" />
              Verify & send message
            </>
          )}
        </button>
        <div className="flex items-center justify-between text-xs">
          <button
            onClick={onBack}
            data-testid="contact-back-button"
            className="text-zinc-400 hover:text-white transition-colors"
          >
            ← Edit details
          </button>
          <button
            onClick={onResend}
            data-testid="contact-resend-otp-button"
            className="text-blue-400 hover:text-blue-300 transition-colors"
          >
            Resend code
          </button>
        </div>
      </div>
    </motion.div>
  );
}
